import React, { useState, useEffect } from "react";
import "./PropertyInHandUpdateModal.css";
import { toast } from "react-toastify";
import HomeService from "../../Services/HomeService";
import HttpClientXml from "../../utils/HttpClientXml";
import { floors } from "./Helper";

const PropertyInHandUpdateModal = ({
  isOpen,
  onClose,
  propertyData,
  onSubmit,
  userId,
}) => {
  console.log("PropertyData", propertyData);
  const [formData, setFormData] = useState({
    propertyType: "",
    propertyFor: "",
    city: "",
    locality: "",
    apartment: "",
    address: "",
    area: "",
    areaUnit: "",
    bhk: "",
    floor: "",
    ownerType: "",
    ownerName: "",
    phoneNumber: "",
    price: "",
    priceUnit: "",
    facing: "",
    features: [],
    age: "",
    locationUrl: "",
    images: [],
    extra: "",
  });

  const [featureInput, setFeatureInput] = useState("");
  const [imageFiles, setImageFiles] = useState([]);
  const [loading, setLoading] = useState(false);

  // Get data from props or fetch if needed
  const [propertyType, setPropertyType] = useState([]);
  const [cities, setCities] = useState([]);
  const [cityWiseLocality, setCityWiseLocality] = useState([]);
  const [cityWiseApartment, setCityWiseApartment] = useState([]);
  const [facings, setFacings] = useState([]);
  // const [floors, setFloors] = useState([
  //   "Ground",
  //   "1",
  //   "2",
  //   "3",
  //   "4",
  //   "5",
  //   "6",
  //   "7",
  //   "8",
  //   "9",
  //   "10",
  // ]);

  // Helper function to update form data
  const updateFormData = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Fetch initial data

  const [propertyTypeAndCityLoading, setPropertyTypeAndCityLoading] =
    useState(false);
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        setPropertyTypeAndCityLoading(true);
        // Fetch property types
        const propertyRes = await HomeService.getPropertyTypes();
        if (propertyRes?.data) {
          setPropertyType(propertyRes.data);
        }

        // Fetch cities
        const citiesRes = await HomeService.getCities({ userId });
        console.log("city", citiesRes);
        if (citiesRes?.data) {
          setCities(citiesRes.data);
        }

        // Fetch facings
        const facingRes = await HomeService.getFacings();
        if (facingRes?.data) {
          setFacings(facingRes.data);
        }
      } catch (error) {
        console.error("Error fetching initial data:", error);
      } finally {
        setPropertyTypeAndCityLoading(false);
      }
    };

    fetchInitialData();
  }, []);

  // Fetch locality when city changes
  const [localityLoading, setLocalityLoading] = useState(false);
  useEffect(() => {
    const fetchLocality = async () => {
      if (formData.city) {
        try {
          setLocalityLoading(true);
          const res = await HomeService.getLocalitiesByCity(formData.city);
          if (res?.status && res?.data) {
            setCityWiseLocality(res.data);
          }
        } catch (error) {
          console.error("Error fetching localities:", error);
        } finally {
          setLocalityLoading(false);
        }
      }
    };

    fetchLocality();
  }, [formData.city]);

  // Fetch apartment when city changes
  const [apartmentLoading, setApartmentLoading] = useState(false);
  useEffect(() => {
    const fetchApartment = async () => {
      if (formData.city) {
        try {
          setApartmentLoading(true);
          const res = await HomeService.getAppartmentByCity(formData.city);
          if (res?.status && res?.data) {
            setCityWiseApartment(res.data);
          }
        } catch (error) {
          console.error("Error fetching apartments:", error);
        } finally {
          setApartmentLoading(false);
        }
      }
    };

    fetchApartment();
  }, [formData.city]);

  // Load property data when modal opens - FIXED THIS PART
  useEffect(() => {
    if (propertyData && propertyData._id) {
      console.log("Loading property data for update:", propertyData);

      // Map the API response to formData structure
      setFormData({
        propertyType:
          propertyData.propertytype?._id || propertyData.propertyType || "",
        propertyFor: propertyData.propertyFor || "",
        city: propertyData.city?._id || propertyData.city || "",
        locality: propertyData.locality?._id || propertyData.locality || "",
        apartment: propertyData.aptName || propertyData.apartment || "",
        address: propertyData.address || "",
        area: propertyData.area || "",
        areaUnit: propertyData.unit || propertyData.areaUnit || "",
        bhk: propertyData.bhk?._id || propertyData.bhk || "",
        floor: propertyData.floor || "",
        ownerType: propertyData.contactType || propertyData.ownerType || "",
        ownerName: propertyData.name || propertyData.ownerName || "",
        phoneNumber: propertyData.phoneNo || propertyData.phoneNumber || "",
        price: propertyData.price || "",
        priceUnit: propertyData.priceUnit || "",
        facing: propertyData.facing?._id || propertyData.facing || "",
        features: propertyData.features || [],
        age: propertyData.age || "",
        locationUrl: propertyData.locationUrl || "",
        images: propertyData.images || [],
        extra: propertyData.extra || "",
      });

      // If city exists, fetch its localities and apartments
      if (propertyData.city?._id) {
        // Fetch localities for this city
        HomeService.getLocalitiesByCity(propertyData.city._id)
          .then((res) => {
            if (res?.status && res?.data) {
              setCityWiseLocality(res.data);
            }
          })
          .catch((err) => console.error("Error fetching localities:", err));

        // Fetch apartments for this city
        HomeService.getAppartmentByCity(propertyData.city._id)
          .then((res) => {
            if (res?.status && res?.data) {
              setCityWiseApartment(res.data);
            }
          })
          .catch((err) => console.error("Error fetching apartments:", err));
      }
    }
  }, [propertyData]);

  const handleAddFeature = () => {
    if (featureInput.trim()) {
      updateFormData("features", [...formData.features, featureInput.trim()]);
      setFeatureInput("");
    }
  };

  const handleRemoveFeature = (featureToRemove) => {
    updateFormData(
      "features",
      formData.features.filter((feature) => feature !== featureToRemove),
    );
  };

  //   const handleImageUpload = async (e) => {
  //     const files = Array.from(e.target.files);

  //     try {
  //       setLoading(true);
  //       const uploadedImages = [];

  //       for (let i = 0; i < files.length; i++) {
  //         const data = new FormData();
  //         data.append("image", files[i]);

  //         const res = await HomeService.uploadImage(data);
  //         if (res?.image) {
  //           uploadedImages.push(res.image);
  //         }
  //       }

  //       setImageFiles([...imageFiles, ...files]);
  //       updateFormData("images", [...formData.images, ...uploadedImages]);
  //       toast.success("Images uploaded successfully!");
  //     } catch (error) {
  //       toast.error("Failed to upload images");
  //       console.error("Error uploading images:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  const [mediaUploadLoading, setMediaUploadLoading] = useState(false);
  const handleImageUpload = async (e) => {
    const files = e.target.files;
    const uploadedImages = [];

    for (let i = 0; i < files.length; i++) {
      const data = new FormData();
      data.append("image", files[i]);

      try {
        setMediaUploadLoading(true);
        const res = await HttpClientXml.fileUplode(
          "image-upload",
          "POST",
          data,
        );
        if (res?.image) {
          uploadedImages.push(res.image);
        }
      } catch (error) {
        toast.error("Failed to upload image: " + files[i].name);
        console.error("Error uploading image:", error);
      } finally {
        setMediaUploadLoading(false);
      }
    }

    setImageFiles((prevImages) => [...prevImages, ...uploadedImages]);
    updateFormData("images", [...formData.images, ...uploadedImages]);
    // toast.success("Images uploaded successfully!");
    toast.success("Media uploaded Successfully!");
  };
  const handleRemoveImage = (indexToRemove) => {
    const updatedImages = formData.images.filter(
      (_, index) => index !== indexToRemove,
    );
    updateFormData("images", updatedImages);
  };

  const handleCityChange = (e) => {
    const cityId = e.target.value;
    updateFormData("city", cityId);
    updateFormData("locality", "");
    updateFormData("apartment", "");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (
      !formData.propertyType ||
      !formData.propertyFor ||
      !formData.city ||
      !formData.locality
      // !formData.address ||
      // !formData.area ||
      // !formData.areaUnit ||
      // !formData.bhk ||
      // !formData.floor ||
      // !formData.ownerType ||
      // !formData.ownerName ||
      // !formData.phoneNumber ||
      // !formData.price ||
      // !formData.priceUnit ||
      // !formData.facing ||
      // formData?.features?.length === 0 ||
      // !formData.age ||
      // !formData.locationUrl ||
      // !formData?.apartment ||
      // formData?.images === 0 ||
      // !formData?.apartment
    ) {
      toast.error("Please fill all required fields");
      return;
    }

    // if (formData.images.length === 0) {
    //   toast.error("Please upload at least one image");
    //   return;
    // }

    if (formData?.phoneNumber && formData?.phoneNumber?.length !== 10) {
      toast.error("Phone Number Should be in 10 digits");
      return;
    }

    if (formData?.price && !formData?.priceUnit) {
      toast.error("If You Enter price then please select price unit ");
      return;
    }

    if (formData?.area && !formData?.areaUnit) {
      toast.error("If You Enter Area then please select Area unit ");
      return;
    }

    try {
      setLoading(true);

      // Prepare data for update - matching your API structure
      const updateData = {
        addedByDealer: userId,
        propertyType: formData.propertyType,
        propertyFor: formData.propertyFor,
        city: formData.city,
        locality: formData.locality,
        aptName: formData.apartment, // Note: API uses aptName
        address: formData.address,
        area: formData.area,
        unit: formData.areaUnit, // Note: API uses unit
        bhk: formData.bhk,
        floor: formData.floor,
        contactType: formData.ownerType, // Note: API uses contactType
        name: formData.ownerName, // Note: API uses name
        phoneNo: formData.phoneNumber, // Note: API uses phoneNo
        price: formData.price,
        priceUnit: formData.priceUnit,
        facing: formData.facing,
        features: formData.features,
        age: formData.age,
        locationUrl: formData.locationUrl,
        images: formData.images,
        extra: formData.extra,
      };

      console.log("Updating property with data:", updateData);
      console.log("Property ID:", propertyData._id);

      // Call update API
      const res = await HomeService.updatePropertyInHand(
        propertyData._id,
        updateData,
      );

      if (res?.status) {
        toast.success("Property updated successfully!");
        if (onSubmit) {
          onSubmit(res.data);
        }
        onClose();
      } else {
        toast.error(res?.message || "Failed to update property");
      }
    } catch (error) {
      console.error("Error updating property:", error);
      toast.error("Failed to update property");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    // Cleanup object URLs to prevent memory leaks
    formData.images.forEach((img) => {
      if (img && typeof img === "string" && img.startsWith("blob:")) {
        URL.revokeObjectURL(img);
      }
    });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h3>Update Property Details</h3>
          <button
            className="modal-close-btn"
            onClick={handleClose}
            disabled={loading}
          >
            ×
          </button>
        </div>

        {propertyTypeAndCityLoading || localityLoading || apartmentLoading ? (
          <div className="modal-overlay">
            <div className="modal-container">
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <button className="modal-close-btn" onClick={handleClose}>
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="loader-container">
                  <div className="spinner"></div>
                  <p>Loading property data...</p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label>
                    Property Type <span className="required">*</span>
                  </label>
                  <select
                    value={formData.propertyType}
                    onChange={(e) =>
                      updateFormData("propertyType", e.target.value)
                    }
                    required
                    disabled={loading}
                  >
                    <option value="">Select Property Type</option>
                    {propertyType.map((type) => (
                      <option key={type._id} value={type._id}>
                        {type.propertyType}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  {console.log("propertyFor", formData?.propertyFor)}
                  <label>
                    Property For <span className="required">*</span>
                  </label>
                  <select
                    value={formData.propertyFor}
                    onChange={(e) =>
                      updateFormData("propertyFor", e.target.value)
                    }
                    required
                    disabled={loading}
                  >
                    <option value="">Select Property For</option>
                    <option value="sale">Sale</option>
                    <option value="rent">Rent</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>
                    City <span className="required">*</span>
                  </label>
                  <select
                    value={formData.city}
                    onChange={handleCityChange}
                    required
                    disabled={loading}
                  >
                    <option value="">Select City</option>
                    {cities.map((city) => (
                      <option key={city._id} value={city._id}>
                        {city.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label>
                    Locality <span className="required">*</span>
                  </label>
                  <select
                    value={formData.locality}
                    onChange={(e) => updateFormData("locality", e.target.value)}
                    required
                    disabled={!formData.city || loading}
                  >
                    <option value="">Select Locality</option>
                    {cityWiseLocality.map((item) => (
                      <option key={item._id} value={item._id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label>Apartment</label>
                  <select
                    value={formData.apartment}
                    onChange={(e) =>
                      updateFormData("apartment", e.target.value)
                    }
                    disabled={!formData.locality || loading}
                  >
                    <option value="">Select Apartment</option>
                    {cityWiseApartment
                      ?.filter(
                        (item) => item?.locality?._id === formData.locality,
                      )
                      ?.map((item) => (
                        <option key={item._id} value={item.aptName}>
                          {item.aptName}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="form-group">
                  <label>Address</label>
                  <input
                    type="text"
                    value={formData.address}
                    onChange={(e) => updateFormData("address", e.target.value)}
                    placeholder="Enter Address"
                    // required
                    disabled={loading}
                  />
                </div>

                <div className="form-group">
                  <label>Area</label>
                  <input
                    type="text"
                    value={formData.area}
                    // onChange={(e) => updateFormData("area", e.target.value)}
                    onChange={(e) => {
                      if (/^\d*$/.test(e.target.value)) {
                        updateFormData("area", e.target.value);
                      }
                    }}
                    placeholder="Enter Area"
                    // required
                    disabled={loading}
                  />
                </div>

                <div className="form-group">
                  <label>Area Unit</label>
                  <select
                    value={formData.areaUnit}
                    onChange={(e) => updateFormData("areaUnit", e.target.value)}
                    // required
                    disabled={!formData.area || loading}
                  >
                    <option value="">Select Area Unit</option>
                    <option value="Feet">Feet</option>
                    <option value="Yard">Yard</option>
                    <option value="Meter">Meter</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>BHK</label>
                  <select
                    value={formData.bhk}
                    onChange={(e) => updateFormData("bhk", e.target.value)}
                    // required
                    disabled={loading}
                  >
                    <option value="">Select Bhk</option>
                    {[
                      "1",
                      "1RK",
                      "2",
                      "2RK",
                      ...Array.from({ length: 33 }, (_, i) =>
                        (i + 3).toString(),
                      ),
                    ].map((bhk, i) => (
                      <option key={i} value={bhk}>
                        {bhk}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label>Floor</label>
                  <select
                    value={formData.floor}
                    onChange={(e) => updateFormData("floor", e.target.value)}
                    // required
                    disabled={loading}
                  >
                    <option value="">Select Floor</option>
                    {floors.map((floor, i) => (
                      <option key={i} value={floor}>
                        {floor}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label>Owner Type</label>
                  <select
                    value={formData.ownerType}
                    onChange={(e) =>
                      updateFormData("ownerType", e.target.value)
                    }
                    // required
                    disabled={loading}
                  >
                    <option value="">Select Owner Type</option>
                    <option value="Owner">Owner</option>
                    <option value="Builder">Builder</option>
                    <option value="Dealer">Dealer</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Owner Name</label>
                  <input
                    type="text"
                    value={formData.ownerName}
                    onChange={(e) =>
                      updateFormData("ownerName", e.target.value)
                    }
                    placeholder="Enter Owner Name"
                    // required
                    disabled={loading}
                  />
                </div>

                <div className="form-group">
                  <label>Phone Number</label>
                  <input
                    type="tel"
                    value={formData.phoneNumber}
                    onChange={(e) =>
                      updateFormData("phoneNumber", e.target.value)
                    }
                    placeholder="Enter Phone Number"
                    // required
                    disabled={loading}
                  />
                </div>

                <div className="form-group">
                  <label>Price</label>
                  <input
                    type="text"
                    value={formData.price}
                    // onChange={(e) => updateFormData("price", e.target.value)}
                    onChange={(e) => {
                      if (/^\d*$/.test(e.target.value)) {
                        setFormData((prev) => ({
                          ...prev,
                          price: e.target.value,
                        }));
                      }
                    }}
                    placeholder="Enter Price"
                    // required
                    disabled={loading}
                  />
                </div>

                <div className="form-group">
                  <label>Price Unit</label>
                  <select
                    value={formData.priceUnit}
                    onChange={(e) =>
                      updateFormData("priceUnit", e.target.value)
                    }
                    // required
                    disabled={loading}
                  >
                    <option value="">Select Price Unit</option>
                    <option value="TH">Thousand</option>
                    <option value="LKH">Lakh</option>
                    <option value="CR">Crore</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>Facing</label>
                  <select
                    value={formData.facing}
                    onChange={(e) => updateFormData("facing", e.target.value)}
                    disabled={loading}
                  >
                    <option value="">Select Facing</option>
                    {facings.map((facing) => (
                      <option key={facing._id} value={facing._id}>
                        {facing.facing}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Features Input - Full Width */}
              <div className="form-group full-width">
                <label>Features</label>
                <div className="features-input-group">
                  <input
                    type="text"
                    value={featureInput}
                    onChange={(e) => setFeatureInput(e.target.value)}
                    placeholder="Enter a feature"
                    disabled={loading}
                  />
                  <button
                    type="button"
                    className="btn-add-feature"
                    onClick={handleAddFeature}
                    disabled={loading}
                  >
                    Add
                  </button>
                </div>
                <div className="features-list">
                  {formData.features.map((feature, index) => (
                    <span
                      key={index}
                      className="feature-badge"
                      onClick={() => !loading && handleRemoveFeature(feature)}
                    >
                      {feature} <span className="remove-icon">×</span>
                    </span>
                  ))}
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Age</label>
                  <input
                    type="number"
                    value={formData.age}
                    onChange={(e) => updateFormData("age", e.target.value)}
                    placeholder="Enter Age"
                    disabled={loading}
                  />
                </div>

                <div className="form-group">
                  <label>Location URL</label>
                  <input
                    type="text"
                    value={formData.locationUrl}
                    onChange={(e) =>
                      updateFormData("locationUrl", e.target.value)
                    }
                    placeholder="Enter Location Url"
                    disabled={loading}
                  />
                </div>
              </div>

              {/* Image Upload - Full Width */}
              <div className="form-group full-width">
                <label>Upload Images + Videos</label>
                <input
                  type="file"
                  onChange={handleImageUpload}
                  multiple
                  // accept="image/*"
                  accept="image/*,video/*"
                  disabled={loading}
                />

                {mediaUploadLoading
                  ? "Uploading Media..."
                  : formData.images.length > 0 && (
                      <div className="image-preview-container">
                        <label>Media Preview:</label>
                        <div className="image-preview-grid">
                          {formData?.images?.map(
                            (img, index) => {
                              if (
                                img?.endsWith(
                                  ".mp4" ||
                                    ".webm" ||
                                    ".mov" ||
                                    ".avi" ||
                                    ".wmv" ||
                                    ".flv" ||
                                    ".mkv" ||
                                    ".mpeg" ||
                                    ".mpg",
                                )
                              ) {
                                return (
                                  <div
                                    key={index}
                                    className="image-preview-wrapper"
                                  >
                                    <video
                                      key={index}
                                      src={img}
                                      controls
                                      style={{
                                        width: "100px",
                                        height: "100px",
                                        margin: "5px",
                                        objectFit: "cover",
                                      }}
                                    />
                                    <button
                                      type="button"
                                      className="image-remove-btn"
                                      onClick={() => handleRemoveImage(index)}
                                      disabled={loading}
                                    >
                                      ×
                                    </button>
                                  </div>
                                );
                              } else {
                                return (
                                  <div
                                    key={index}
                                    className="image-preview-wrapper"
                                  >
                                    <img
                                      src={img}
                                      alt={`Preview ${index + 1}`}
                                      className="image-preview"
                                    />
                                    <button
                                      type="button"
                                      className="image-remove-btn"
                                      onClick={() => handleRemoveImage(index)}
                                      disabled={loading}
                                    >
                                      ×
                                    </button>
                                  </div>
                                );
                              }
                            },
                            // <div key={index} className="image-preview-wrapper">
                            //   <img
                            //     src={img}
                            //     alt={`Preview ${index + 1}`}
                            //     className="image-preview"
                            //   />
                            //   <button
                            //     type="button"
                            //     className="image-remove-btn"
                            //     onClick={() => handleRemoveImage(index)}
                            //     disabled={loading}
                            //   >
                            //     ×
                            //   </button>
                            // </div>
                          )}
                        </div>
                      </div>
                    )}
              </div>

              <div className="form-group full-width">
                <label>Extra</label>
                <textarea
                  value={formData.extra}
                  onChange={(e) => updateFormData("extra", e.target.value)}
                  placeholder="Enter Extra"
                  rows="4"
                  disabled={loading}
                />
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn-cancel"
                  onClick={handleClose}
                  disabled={loading}
                >
                  Cancel
                </button>
                <button type="submit" className="btn-submit" disabled={loading}>
                  {loading ? "Updating..." : "Update Property"}
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default PropertyInHandUpdateModal;
